/**
 * Small badge ("eyebrow") shown above a block's heading — a rounded pill with a
 * star + label, matching the hero block's eyebrow. Renders nothing when empty,
 * so it's safe to drop into any block above its heading.
 */
export function EyebrowPill({text, align = 'center'}: {text?: string; align?: 'center' | 'start'}) {
  if (!text) return null;
  return (
    <div className={align === 'center' ? 'text-center' : 'text-start'}>
      <span className="mb-10 inline-flex items-center gap-6 rounded-full bg-primary/10 px-14 py-6 text-xs font-semibold text-primary">
        <span className="material-icons text-sm">stars</span>
        {text}
      </span>
    </div>
  );
}
